import { BsHeart, BsHeartFill } from 'react-icons/bs';
import {
  Button,
  ButtonProps,
  useBoolean,
  useDisclosure,
} from '@chakra-ui/react';

import { FaHandshake } from 'react-icons/fa';
import React, { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { likeJob } from '~/queries';
import { Job, Mutation } from '~/generated';
import { useUser } from '~/containers';
import { AuthState } from '@aws-amplify/ui-components';
import SignInModal from '~/components/organisms/SignInModal';

const likeButtonText = (accepted: boolean, liked: boolean) => {
  if (accepted) return '応募済み';
  if (liked) return '興味あり済み';

  return '興味あり';
};

const likeButtonIcon = (accepted: boolean, liked: boolean) => {
  if (accepted) return <FaHandshake color="blue" />;
  if (liked) return <BsHeartFill color="lightblue" />;

  return <BsHeart />;
};

const LikeButton: React.FC<ButtonProps & { job: Job }> = ({
  job,
  width,
  colorScheme,
}) => {
  const { id, liked, accepted } = job;
  const [hasLiked, { toggle }] = useBoolean(accepted || liked || false);
  const [buttonDisabled, { on: disableButton, off: enableButton }] = useBoolean(
    accepted || false,
  );
  const [updateLikeJob, { error, data, loading }] =
    useMutation<Pick<Mutation, 'likeJob'>>(likeJob);
  const { user } = useUser();

  const { isOpen, onToggle } = useDisclosure();

  const handleLike = async () => {
    if (accepted) return;
    if (!user) {
      onToggle();

      return;
    }

    toggle();
    disableButton();
    await updateLikeJob({ variables: { id } });

    if (data?.likeJob?.liked != null && hasLiked !== data?.likeJob?.liked) {
      toggle();
    }
  };

  useEffect(() => {
    if (error) {
      toggle();
      enableButton();
    }
  }, [error, toggle, enableButton]);

  return (
    <>
      <Button
        opacity="100%"
        onClick={() => {
          void handleLike();

          return undefined;
        }}
        disabled={accepted || loading || buttonDisabled || liked || false}
        variant="outline"
        size="md"
        fontWeight="extrabold"
        backgroundColor="white"
        _focus={{ shadow: 'none' }}
        minW={{ base: '100px', md: '200px' }}
        width={width}
        colorScheme={colorScheme}
      >
        <span style={{ marginRight: '6px' }}>
          {likeButtonIcon(accepted || false, hasLiked)}
        </span>
        {likeButtonText(accepted || false, hasLiked)}
      </Button>
      <SignInModal
        isOpen={isOpen}
        onClose={onToggle}
        defaultAuthState={AuthState.SignUp}
      />
    </>
  );
};

export default LikeButton;
